export default "__VITE_ASSET__DnYg1RrS__"